import type { MongoAbility } from '@casl/ability'

import { createAliasResolver } from '@casl/ability'

export enum Action {
  ALL = 'ALL',
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum Permission {
  NARUS_TEAM = 'narus-team',
  IGAO_CLINICAL = 'igao-clinical',
  ESCALATE_SUMMARY = 'escalate-summary',
  CLAIM_HISTORY = 'clim-history',
  MEDICAL_HISTORY = 'medical-history',
  ASSESSMENTS = 'assessments',
  ALLERGIES = 'allergies',
  MEDICATIONS = 'medications',
  SOCIAL_HISTORY = 'social-history',
  DIAGNOSTICS_DOCUMENTS = 'diagnostics-documents',
  GOALS = 'goals',
  UTILIZATION = 'utilization',
  NEW_REPORT_ENCOUNTER = 'new-report-encounter',
  CASE_MANAGEMENT = 'case-management',
  ACTIVE_MEDICATIONS = 'active-medications'
}

createAliasResolver({
  [Action.ALL]: [
    Action.CREATE,
    Action.READ,
    Action.UPDATE,
    Action.DELETE
  ]
})

export type AppAbility = MongoAbility<[Action, Permission]>
